import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useMainRecommendedItems() {
    const { data } = useQuery(queries.recommendedItems.main());
    return data;
}

export default useMainRecommendedItems;
